import { render, staticRenderFns } from "./shipping-quote-form.vue?vue&type=template&id=5e1b4324&"
import script from "./shipping-quote-form.vue?vue&type=script&lang=js&"
export * from "./shipping-quote-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports